import { render } from "./BooleanPropertyControl.vue?vue&type=template&id=2b304dfd&scoped=true"
import script from "./BooleanPropertyControl.vue?vue&type=script&lang=js"
export * from "./BooleanPropertyControl.vue?vue&type=script&lang=js"

import "./BooleanPropertyControl.vue?vue&type=style&index=0&id=2b304dfd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b304dfd"]])

export default __exports__